// src/belediye/components/ui/SearchBox.js
//
// Paylaşılan arama kutusu — tüm sayfalarda AYNI görünüm/davranış.
// (Başvurular + Yönlendirilenler + ileride diğerleri buradan kullanır.)

import React from "react";
import {
  MagnifyingGlassIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

import "./SearchBox.css";

export default function SearchBox({
  value,
  onChange,
  onClear,
  placeholder = "Ara…",
  className = "",
}) {
  const handleClear = () => {
    if (typeof onClear === "function") onClear();
    else if (typeof onChange === "function") onChange("");
  };

  return (
    <div className={`ui-search ${className}`.trim()}>
      <MagnifyingGlassIcon className="ui-search-icon" />
      <input
        className="ui-search-input"
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        placeholder={placeholder}
      />
      {value ? (
        <button
          type="button"
          className="ui-search-clear"
          onClick={handleClear}
          title="Aramayı temizle"
          aria-label="Aramayı temizle"
        >
          <XMarkIcon />
        </button>
      ) : null}
    </div>
  );
}
